import React, { Component } from 'react';
import PropTypes from 'prop-types';


class JoinInvestorCard extends Component {
  static propTypes = {
    record: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      added: props.record.added,
      loading: false,
    };
  }

  postRequest = () => {
    const { record } = this.props;
    this.setState({ loading: true });
    App.Api.post(record.add_url)
      .then(() => {
        this.setState({ added: true, loading: false });
        window.location.href = record.redirect_url;
      })
      .catch(() => {
        App.State.setFlash({
          name: 'alert',
          msg: 'Request failed',
        });
      });
  }

  request = () => {
    const { loading, added } = this.state;

    if (loading) {
      return (
        <div className="btn bg-white border border-light-green h5 p1 rounded text-light-green cursor-pointer">
          <i className="fa fa-refresh fa-spin fa-fw" />
          Loading..
        </div>
      );
    }
    if (added) {
      return (
        <div className="btn bg-white border border-light-green h5 p1 rounded text-light-green cursor-pointer">
          Requested
        </div>
      );
    }
    return (
      <div className="btn bg-blue border-none cursor-pointer inline-block h5 p1 rounded text-white" onClick={this.postRequest}>
        Request join
      </div>
    );
  }

  render() {
    const { record } = this.props;

    return (
      <div className="col-4 lg-col-6 sm-col-12 flex px2 mb3">
        <div className="card--has-hover bg-white bs-around-small center flex flex-auto flex-center flex-column p3 relative rounded">
          <div className="flex-auto">
            <i className="fa fa-briefcase fa--search-card absolute position-right-top text-extra-light-gray" />
            <div
              className="search-card__img bg-center bg-cover bg-no-repeat border border-light-gray circle mb1 mx-auto"
              style={{ backgroundImage: `url(${record.avatar})` }}
            />
            <p className="bold h3 m0 mb1 text-outer-space">{record.name}</p>
            <p className="h5 m0 mb3 text-light-gray">{record.about}</p>
          </div>
          {this.request()}
        </div>
      </div>
    );
  }
}

export default JoinInvestorCard;
